import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setComponentActive } from "../../reducers/userConfigSlice";
import { useShopLogout } from "../../hooks/useShopLogout";
import "./style.css";

export const Profile = () => {
  const userData = useSelector(state => state.aplicationConfig.userConfig.userData);
  const { pathname } = useLocation();
  const dispatch = useDispatch();
  const { logOff, loggingOut } = useShopLogout();
  return <aside className="profile-container-menu" aria-label="Mi cuenta">
    <div className="profile-card-header">
      <strong className="profile-card-name">{userData?.fullname}</strong>
      <span>{userData?.email}</span><span>{userData?.phone}</span>
    </div>
    <nav className="profile-card-body" aria-label="Secciones de mi cuenta">
      {[["details", "Mis datos"], ["history", "Mis pedidos"], ["delivery-options", "Direcciones"], ["invoice-options", "Facturación"], ["policies", "Privacidad"]].map(([path, label]) =>
        <NavLink key={path} className={({isActive}) => isActive || (path === "history" && pathname.startsWith("/order-tracking/")) ? "active" : ""} to={`/${path}`} onClick={() => dispatch(setComponentActive(path))}>{label}</NavLink>)}
    </nav>
    <button type="button" className="menu-logout" disabled={loggingOut} aria-busy={loggingOut} onClick={logOff}>{loggingOut ? "Cerrando sesión…" : "Cerrar sesión"}</button>
  </aside>;
};
